module.exports = __webpack_public_path__ + "static/media/angle-double-right.fb8421fe.svg";